import { ApplePayPaymentMethod } from "../../payment";
import { device } from "./device";
import { AnyAction } from "redux";
import { InitializeDevicePaymentMethodButtonActions } from "src/common/experience/interface";
import { getApplePayBehavior } from "./paymentGateways/behaviors";

export const applePay = {
    isAvailable: async (applePayPaymentMethod: ApplePayPaymentMethod, trackEvent: (action: AnyAction) => void) => {
        if (!device.isIOS) return false;

        const available = await getApplePayBehavior(applePayPaymentMethod)?.getAvailable(
            applePayPaymentMethod,
            trackEvent
        );

        return !!available;
    },
    initializeButton: (
        applePayPaymentMethod: ApplePayPaymentMethod,
        total: number,
        actions: InitializeDevicePaymentMethodButtonActions,
        cancelPromise: Promise<void>
    ) =>
        getApplePayBehavior(applePayPaymentMethod)!.initializeButton(
            applePayPaymentMethod,
            total,
            actions,
            cancelPromise
        ),
    vaultPaymentMethod: () => Promise.resolve(null),
    canVaultPaymentMethod: () => false,
    completePayment: (applePayPaymentMethod: ApplePayPaymentMethod, token?: string) =>
        getApplePayBehavior(applePayPaymentMethod)!.completePayment?.(applePayPaymentMethod, token) ??
        Promise.resolve(),
};
